import { render, staticRenderFns } from "./supplyStuff.vue?vue&type=template&id=1afc2ca3&scoped=true"
import script from "./supplyStuff.vue?vue&type=script&lang=js"
export * from "./supplyStuff.vue?vue&type=script&lang=js"
import style0 from "./supplyStuff.vue?vue&type=style&index=0&id=1afc2ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc2ca3",
  null
  
)

export default component.exports